<div class="page-content">
  <!-- Header Section -->
  <div class="page-title-container">
    <div class="breadcrumb-spacer"></div>
    <h1 class="page-title">Feature Flag Management</h1>
  </div>

  <!-- Loading State -->
  @if (isLoading) {
    <div class="loading-state">
      <mat-spinner diameter="32"></mat-spinner>
      <p>Loading feature flags...</p>
    </div>
  }

  <!-- Access Denied State -->
  @if (accessDenied && !isLoading) {
    <div class="error-state access-denied">
      <mat-icon>lock</mat-icon>
      <span
        >Feature flag management is restricted to users with Super Admin
        role.</span
      >
      <span class="sub-text"
        >If you believe you should have access, please contact your system
        administrator.</span
      >
    </div>
  }

  <!-- Content (filters + error or list) -->
  @if (!isLoading && !accessDenied) {
    <div class="feature-flags-container">
      <!-- Search Bar -->
      <mat-card class="filters-card">
        <mat-card-content>
          <form class="filters-form">
            <div class="filter-row">
              <mat-form-field appearance="outline" class="search-field">
                <mat-label>Search feature flags</mat-label>
                <input
                  matInput
                  [(ngModel)]="searchQuery"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="Search by name or description..."
                  autocomplete="off"
                  (input)="onSearchInput()"
                />
                <mat-icon
                  matSuffix
                  [style.cursor]="searchQuery ? 'pointer' : 'default'"
                  (click)="clearSearch()"
                  >{{ searchQuery ? "close" : "search" }}</mat-icon
                >
              </mat-form-field>
            </div>
          </form>
        </mat-card-content>
      </mat-card>

      <!-- Error State -->
      @if (error) {
        <app-error-state
          [message]="error"
          (retry)="loadFeatureFlags()"
        ></app-error-state>
      }

      <!-- Feature Flags List -->
      @if (!error) {
        <mat-card class="feature-flags-card">
          @if (filteredFeatureFlags.length === 0) {
            <div class="empty-state">
              <i class="material-symbols-outlined empty-icon">flag</i>
              <h3>No feature flags found</h3>
              <p>There are no feature flags matching your search.</p>
            </div>
          } @else {
            <div class="feature-flags-list">
              @for (
                flag of filteredFeatureFlags;
                track trackByFlagId($index, flag);
                let last = $last
              ) {
                <div
                  class="feature-flag-item"
                  [class.archived]="flag.isArchived"
                >
                  <div class="feature-flag-header">
                    <h3 class="feature-flag-name">{{ flag.name }}</h3>
                    <mat-slide-toggle
                      [checked]="flag.isEnabled"
                      [disabled]="flag.isArchived"
                      (change)="toggleFeatureFlag(flag)"
                      color="primary"
                      class="toggle-success"
                      [hideIcon]="true"
                    ></mat-slide-toggle>
                  </div>
                  <p class="feature-flag-description">{{ flag.description }}</p>
                  @if (flag.isArchived) {
                    <mat-chip class="archived-chip" disabled>
                      <mat-icon matChipAvatar>archive</mat-icon>
                      Archived
                    </mat-chip>
                  }
                </div>
                @if (!last) {
                  <mat-divider></mat-divider>
                }
              }
            </div>
          }
        </mat-card>
      }
    </div>
  }
</div>
